import _ from "lodash";
import { ACTION_MAPPING, EMPTY_STRING } from "./constants";
import { isLimitSnapshotEmpty } from './utils'

/* Validation Logic for Lender Ranking */

export function updateLenderRankingInputAmountValidationState(
  currentValidationState,
  productKey,
  lenderKey,
  isInvalidInputMessage,
  isInvalidInput = true
) {
  let lenderRankingValidationsInnerMap =
    currentValidationState.get(productKey).lenderRankingValidationsMap;

  // updating the input amount validation state
  lenderRankingValidationsInnerMap.get(lenderKey).isInvalidInputAmountMessage =
    isInvalidInputMessage;
  lenderRankingValidationsInnerMap.get(lenderKey).isInvalidInputAmount =
    isInvalidInput;
  currentValidationState.get(productKey).lenderRankingValidationsMap =
    lenderRankingValidationsInnerMap;
}

export function updateLenderRankingInputRankValidationState(
  currentValidationState,
  productKey,
  lenderKey,
  isInvalidInputMessage,
  isInvalidInput = true,
  duplicateRankLender = false
) {
  let lenderRankingValidationsInnerMap =
    currentValidationState.get(productKey).lenderRankingValidationsMap;

  // updating the input rank validation state
  lenderRankingValidationsInnerMap.get(lenderKey).isInvalidInputRank =
    isInvalidInput;
  lenderRankingValidationsInnerMap.get(lenderKey).isInvalidInputRankMessage =
    isInvalidInputMessage;
  lenderRankingValidationsInnerMap.get(lenderKey).isDuplicateRankLender =
    duplicateRankLender;
  currentValidationState.get(productKey).lenderRankingValidationsMap =
    lenderRankingValidationsInnerMap;
}

export function updateLenderRankingInputAmountExceededForProductValidationState(
  currentValidationState,
  productKey,
  isInvalidInputMessage,
  isInvalidInput = true
) {
  // updating the input amount exceeded for product validation state
  currentValidationState.get(productKey).isTotalAmountExceeded = isInvalidInput;
  currentValidationState.get(productKey).isTotalAmountExceededMessage =
    isInvalidInputMessage;
}

export function updateLenderRankingDuplicateRankPresentForProductValidationState(
  currentValidationState,
  productKey,
  duplicateRankLenderPresentForProduct = true
) {
  // updating duplicate rank lender present for product validation state
  currentValidationState.get(
    productKey
  ).isDuplicateRankLenderPresentForProduct =
    duplicateRankLenderPresentForProduct;
}

export function removeInvalidMessageOnLenderRankingInputFieldChange(
  action,
  productID,
  lenderID,
  updateValidationState,
  newCycle
) {
  let isRemoved = false;
  const lenderRankingValidationsInnerMap =
    updateValidationState.get(productID).lenderRankingValidationsMap;
  if (action === ACTION_MAPPING.saveLimit) {
    if (lenderRankingValidationsInnerMap.get(lenderID).isInvalidInputAmount) {
      isRemoved = true;
      updateLenderRankingInputAmountValidationState(
        updateValidationState,
        productID,
        lenderID,
        EMPTY_STRING,
        false
      );
    }
    if (updateValidationState.get(productID).isTotalAmountExceeded) {
      isRemoved = true;
      updateLenderRankingInputAmountExceededForProductValidationState(
        updateValidationState,
        productID,
        EMPTY_STRING,
        false
      );
    }
  } else if (action === ACTION_MAPPING.saveLenderRank) {
    if (
      lenderRankingValidationsInnerMap.get(lenderID).isInvalidInputRankMessage
    ) {
      isRemoved = true;
      updateLenderRankingInputRankValidationState(
        updateValidationState,
        productID,
        lenderID,
        EMPTY_STRING,
        false
      );
    } else if (
      updateValidationState.get(productID)
        .isDuplicateRankLenderPresentForProduct
    ) {
      removeDuplicateInputMessageOnLenderRankingInputRankChange(
        productID,
        updateValidationState,
        newCycle,
        isRemoved
      );
    }
  }
  return isRemoved;
}

export function removeDuplicateInputMessageOnLenderRankingInputRankChange(
  productID,
  updateValidationState,
  newCycle,
  isRemoved
) {
  const lenderRankingValidationsInnerMap =
    updateValidationState.get(productID).lenderRankingValidationsMap;
  const product = newCycle[productID];
  const lenderKeys = _.keys(product.lenders);
  lenderKeys.forEach((lenderKey) => {
    if (lenderRankingValidationsInnerMap.get(lenderKey).isDuplicateRankLender) {
      isRemoved = true;
      updateLenderRankingInputRankValidationState(
        updateValidationState,
        productID,
        lenderKey,
        EMPTY_STRING,
        false
      );
    }
  });
  isRemoved = true;
  updateLenderRankingDuplicateRankPresentForProductValidationState(
    updateValidationState,
    productID,
    false
  );
}

export function validateLenderRankingInputFieldsOnClickNext(
  newCycle,
  newValidationState,
  isEditLenderRanking,
  translate
) {
  let isValidInput = true;
  _.keys(newCycle).forEach((productKey) => {
    const product = newCycle[productKey];
    const lenderKeys = _.keys(product.lenders);
    const totalLenders = lenderKeys.length;
    let totalLenderLimitSnapshot = 0;
    const productLimitSnapshot = Number(product.product_limit_snapshot);
    const rankMap = new Map();
    let isValidInputRank = true;
    let isValidInputNumber = true;
    lenderKeys.forEach((lenderKey) => {
      const lender = product.lenders[lenderKey];
      const canFund = product.lenders[lenderKey].can_fund;
      const isValidLenderLimitAmount = /^\d+$/.test(
        lender.lender_limit_snapshot
      );
      const isValidLenderRank = /^\d+$/.test(lender.rank);

      if (isLimitSnapshotEmpty(lender.lender_limit_snapshot)) {
        updateLenderRankingInputAmountValidationState(
          newValidationState,
          productKey,
          lenderKey,
          translate("errorMessages.ovo_admin_error_field_required")
        );
        isValidInputNumber = false;
      } else if (Number(lender.lender_limit_snapshot) === 0) {
        updateLenderRankingInputAmountValidationState(
          newValidationState,
          productKey,
          lenderKey,
          translate("errorMessages.ovo_admin_error_amount_greater_than_zero")
        );
        isValidInputNumber = false;
      } else if (!isValidLenderLimitAmount) {
        updateLenderRankingInputAmountValidationState(
          newValidationState,
          productKey,
          lenderKey,
          translate("errorMessages.ovo_admin_error_invalid_value")
        );
        isValidInputNumber = false;
      } else if (Number(lender.lender_limit_snapshot) > productLimitSnapshot) {
        updateLenderRankingInputAmountValidationState(
          newValidationState,
          productKey,
          lenderKey,
          translate("errorMessages.ovo_admin_error_amount_high").replace(
            "${productValue}",
            productLimitSnapshot
          )
        );
        isValidInputNumber = false;
      }

      if (lender.rank === -1 || lender.rank === "") {
        updateLenderRankingInputRankValidationState(
          newValidationState,
          productKey,
          lenderKey,
          translate("errorMessages.ovo_admin_error_field_required")
        );
        isValidInputRank = false;
      } else if (Number(lender.rank) === 0) {
        updateLenderRankingInputRankValidationState(
          newValidationState,
          productKey,
          lenderKey,
          translate("errorMessages.ovo_admin_error_no_input_on_rank")
        );
        isValidInputRank = false;
      } else if (!isValidLenderRank) {
        updateLenderRankingInputRankValidationState(
          newValidationState,
          productKey,
          lenderKey,
          translate("errorMessages.ovo_admin_error_invalid_value")
        );
        isValidInputRank = false;
      } else if (Number(lender.rank) > totalLenders) {
        updateLenderRankingInputRankValidationState(
          newValidationState,
          productKey,
          lenderKey,
          translate(
            "errorMessages.ovo_admin_error_rank_higher_than_selected"
          ).replace("${totalLenders}", totalLenders)
        );
        isValidInputRank = false;
      } else if (
        (!isEditLenderRanking || canFund) &&
        rankMap.has(Number(lender.rank))
      ) {
        updateLenderRankingInputRankValidationState(
          newValidationState,
          productKey,
          lenderKey,
          translate("errorMessages.ovo_admin_error_rank_repeated"),
          true,
          true
        );
        //duplicate rank lender found - if duplicate rank lender present for product is not set as true then set it as true
        if (
          !newValidationState.get(productKey)
            .isDuplicateRankLenderPresentForProduct
        ) {
          updateLenderRankingDuplicateRankPresentForProductValidationState(
            newValidationState,
            productKey
          );
        }
        isValidInputRank = false;
      }
      if (!isEditLenderRanking || canFund) {
        rankMap.set(Number(lender.rank), lenderKey);
      }
      totalLenderLimitSnapshot += Number(lender.lender_limit_snapshot);
    });
    if (isValidInputNumber && totalLenderLimitSnapshot !== productLimitSnapshot) {
      updateLenderRankingInputAmountExceededForProductValidationState(
        newValidationState,
        productKey,
        translate(
          "errorMessages.ovo_admin_error_doesnt_match_allocated_amt"
        ).replace("${totalSumAmount}", productLimitSnapshot)
      );
      isValidInputNumber = false;
    }
    if(isValidInput){
      isValidInput = isValidInputNumber && isValidInputRank;
    }
  });
  return isValidInput;
}

/* Validation Logic for Setup Limit */

export function updateSetupLimitInputFieldsValidationState(
  currentValidationState,
  key,
  isInvalidInput,
  invalidInputMessage
) {
  currentValidationState.set(key, {
    isInvalidInput: isInvalidInput,
    invalidInputMessage: invalidInputMessage,
  });
}

export function removeInvalidMessageOnSetupLimitInputFieldChange(
  productID,
  updateValidationState
) {
  let isRemoved = false;
  if (updateValidationState.get(productID).isInvalidInput) {
    updateSetupLimitInputFieldsValidationState(
      updateValidationState,
      productID,
      false,
      ""
    );
    isRemoved = true;
  }
  return isRemoved;
}

export function validateSetupLimitInputFieldsOnClickNext(
  products,
  newCycle,
  newValidationState,
  translate
) {
  let isValidInput = true;
  products.forEach((product) => {
    const productValue = newCycle[product.code];
    let isnum = /^\d+$/.test(productValue.product_limit_snapshot);
    if (isLimitSnapshotEmpty(productValue.product_limit_snapshot)) {
      updateSetupLimitInputFieldsValidationState(
        newValidationState,
        product.code,
        true,
        translate("errorMessages.ovo_admin_error_field_required")
      );
      isValidInput = false;
    } else if (!isnum) {
      updateSetupLimitInputFieldsValidationState(
        newValidationState,
        product.code,
        true,
        translate("errorMessages.ovo_admin_error_invalid_value")
      );
      isValidInput = false;
    } else if (Number(productValue.product_limit_snapshot) === 0) {
      updateSetupLimitInputFieldsValidationState(
        newValidationState,
        product.code,
        true,
        translate("errorMessages.ovo_admin_error_amount_greater_than_zero")
      );
      isValidInput = false;
    }
  });
  return isValidInput;
}
